import styled from 'styled-components';

export const StyledAppContainer = styled.div`
  height: 100vh;
  min-height: 100vh;
  overflow-x: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: #202327;
  background-position: top right;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url('./images/backgrounds/background-hex-grid.png');

  @media (max-width: 1024px) {
    height: auto;
  }
`;
